import { cn } from '@latitude/token-utils';
import type { JSX } from 'react';

import type { SVGProps } from '../types';

const SwitchIcon = (props: SVGProps): JSX.Element => {
  const { title = 'Switch', className, ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      className={cn('fill-current', className)}
      {...restProps}
    >
      <title>{title}</title>
      <path
        fillRule="evenodd"
        d="M5.333 2v9.724l2-2 .943.943-3.138 3.138a.667.667 0 0 1-.943 0l-3.138-3.138L2 9.724l2 2V2zm5.529.195c.26-.26.682-.26.943 0l3.138 3.138-.943.943-2-2V14h-1.333V4.276l-2 2-.943-.943z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export { SwitchIcon };
